import { Icon } from 'gu-ui-kit'
import React from 'react'

export default () => {
  return {
    initial: {
      search: '',
      statuses: [],
      payment_profile_ids: [],
    },
    configuration: {
      search: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'invoices::filters.dropdown.items.search.label',
        placeholder: 'invoices::filters.dropdown.items.search.label',
        order: 1,
        type: 'input',
      },
      statuses: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'Accent-Confirm-Secondary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'invoices::filters.dropdown.items.statuses.label',
        position: 'dropdown',
        type: 'checkbox group',
        optionLabelPrefix: 'invoices::statuses.',
        options: ['new', 'pending', 'waiting', 'paid', 'canceled'],
      },
      payment_profile_ids: {
        subbutton: {
          isVisible: (value = [], breakpoints) => value.length > 0 || !breakpoints.fb,
        },
        icon: (
          <Icon
            name={'avatar1'}
            size={'s'}
            bgColor={'Accent-Confirm-Secondary'}
            color={'Label-Onsurface'}
          />
        ),
        label: 'invoices::filters.dropdown.items.payment_profile_ids.label',
        position: 'dropdown',
        type: 'checkbox group',
        options: [],
      },
    },
  }
}
